import React from "react";
const Loops = () => {
    return (
        <div id={"loops"}>
            <h3>Loops</h3>
            <p>
                <p>
                    Use Loop blocks to execute a set of blocks repeatedly for a specified number of times, or while a condition is met.
                </p>

                <div className={'imageContainer'}>
                    <img src="images/loops.png" alt="Loops" />
                </div>

                <p>
                    It is often useful to maintain a &#39;counter&#39; to keep track of how many times the code blocks have been executed.
                </p>

                <p>
                    For instance, the &#39;count with&#39; block below will repeat the print statement 10 times,
                    and after each iteration of the loop, the &#39;i&#39; variable (see <a
                        href="#variables">Variables</a> section) will be incremented by one. The first
                    iteration of the loop will print the first element of the list called &#39;myList&#39;, the
                    second iteration will print the second element of &#39;myList&#39;, and so on.
                </p>

                <div className={'imageContainer'}>
                    <img src="images/countWithLoopStatement.png" alt="Count with Loop Statement" />
                </div>

                <p>
                    You can also loop through each item of a list (similar to how the
                    block above loops through the first 10 items).
                </p>

                <p>
                    The &#39;for each item in list&#39; block will repeat its inner statement(s) as many times as
                    there are items in the provided list. At each new iteration of the loop, the
                    specified variable will have the value of the next item in the list.
                </p>

                <p>
                    For example, the block below will loop through &#39;myList&#39; and print each item of the list.
                </p>

                <div className={'imageContainer'}>
                    <img src="images/forEachItemInList.png" alt="For each item in list" />
                </div>


                <p>
                    The break/continue block is used within loops to control flow.
                    <b>Break</b> exits the loop immediately, while <b>Continue</b> skips the current iteration and moves to the next one.
                </p>


            </p>
        </div>

    );
}

export default Loops; 
